import { message } from 'antd';

export const handleHideFinancials = async (
  currentRoles: any,
  updateFinancials: any,
) => {
  try {
    const { __typename, ...roles } = currentRoles;

    await updateFinancials({
      variables: {
        data: {
          ...roles,
          generalPermissions: {
            ...roles.generalPermissions,
            financials: !roles.generalPermissions.financials,
          },
        },
      },
    });
    message.success('Changes saved');
  } catch (error) {
    message.error('Failed to save changes');
    console.error(error);
  }
};
